import storeImg from '../assets/landing/store.png';
import googleImg from '../assets/landing/google.png';
import showrunnerLogo from '../assets/images/SHOWRUNNER.png';
import iphone1 from '../assets/landing/iphone-new.png';
import artLanding from '../assets/landing/landing_art.gif';

const ExampleComponent = () => {
  return (
    <>
      <section
        className="relative font-oswald overflow-x-hidden bg-white min-h-[calc(100vh-80px)] flex flex-col justify-center"
        id="home"
      >
        <div className="w-full container mx-auto max-w-[1280px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 items-center">
            <div className="text-sm py-20 px-10">
              <span className="inline-flex py-2 text-lg text-black font-medium items-center justify-center rounded-full">
                <i data-lucide="minus"></i> Discover art shows and exhibitions
              </span>
              <h1
                style={{ lineHeight: 1.2 }}
                className="md:text-4xl text-4xl text-dark tracking-wide font-bold mb-4 mt-6"
              >
                Showrunner is an art platform for discovering shows, exhibitions and galleries — and
                connecting with the people around them.
              </h1>
              <p className="text-base font-medium text-muted leading-7 mt-5">
                Now live in <span className="text-dark-red">New York</span>,{' '}
                <span className="text-dark-red">Los Angeles</span>, and{' '}
                <span className="text-dark-red">Bogotá</span>.
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-start mt-9">
                <a
                  className="inline-block"
                  href="https://apps.apple.com/us/app/showrunner-app/id6745201078"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={storeImg} className="h-14" alt="apple" />
                </a>
                <a
                  className="inline-block"
                  href="https://play.google.com/store/apps/details?id=com.sahirgomez.showrunnermobile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={googleImg} className="h-14" alt="google" />
                </a>
              </div>
              <div className="max-w-md mx-auto md:mx-0 md:mr-auto text-center">
                <a className="inline-block" href="/feed">
                  <div className="flex items-center justify-center gap-4 p-4 px-6 mt-16 rounded-full bg-white shadow-2xl">
                    <h2 className="text-md md:text-lg font-semibold text-dark-red text-center">
                      Browse shows on web now
                    </h2>
                  </div>
                </a>
              </div>
            </div>

            <div className="sm:mt-0 sm:pt-0 relative">
              <img src={iphone1} alt="" className="h-[620px] max-w-full mx-auto" />

              <div className="absolute top-4 -end-14 2xl:end-8 hidden xl:block">
                <div className="flex items-center gap-2 p-2 pe-6 rounded-full bg-white shadow-2xl">
                  <div className="rounded-full h-9 w-9 items-center justify-center flex">
                    <img src={showrunnerLogo} className="h-8 w-8" alt="Showrunner Logo" />
                  </div>
                  <div className="mr-2">
                    <h6 className="text-sm font-medium text-default-900">
                      View live art exhibitions
                    </h6>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-56 start-16 hidden xl:block">
                <div className="flex items-center gap-2 p-2 pe-6 rounded-full bg-white shadow-2xl">
                  <div className="rounded-full h-8 w-8 items-center justify-center flex">
                    <img src={showrunnerLogo} className="h-8 w-8" alt="Showrunner Logo" />
                  </div>

                  <h6 className="text-sm font-medium text-default-900 text-center mr-2">
                    Save shows and share with friends
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="py-32 px-5 md:px-0 font-oswald bg-white">
        <div className="container mx-auto max-w-[1280px]">
          <div className="grid lg:grid-cols-2 items-center gap-6">
            <div className="flex items-center">
              <img
                src={artLanding}
                className="h-auto md:h-[650px] rounded-xl mx-auto"
                alt="feature section"
              />
            </div>

            <div className="lg:ms-5 ms-8">
              <h2 className="text-3xl md:text-4xl/tight font-semibold text-black mt-4">
                Navigating the Art World with Showrunner
              </h2>

              <hr className="border-gray-200 my-6"></hr>
              <div>
                <h4 className="text-xl font-semibold">Discover Art Across NY & LA</h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Browse a feed of all current shows, with filters by medium, style, subject,
                  neighborhood, and more. Easily find specific shows on the map or discover
                  something new nearby.
                </p>
              </div>

              <div className="mt-8">
                <h4 className="text-xl font-semibold">Track Your Year in Art</h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Mark shows as “seen” to keep a personal record of the exhibitions you've
                  experienced and view what others are seeing.
                </p>
              </div>
              <div className="mt-8">
                <h4 className="text-xl font-semibold">Save & Share Your Favorites</h4>
                <p className="text-base font-normal text-gray-500 mt-2">
                  Create custom lists of shows you want to see and share them with friends to plan
                  gallery visits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExampleComponent;
